<template>
    <div class="pa-5">
        <v-row
            no-gutters
            justify="space-between"
            v-if="hasPermissionForAction(PermissionsConstants.PRODUCT, PermissionsConstants.UPLOAD)"
        >
            <v-col cols="10">
                <v-file-input multiple chips :label="t('Upload files')" :value="files" @change="updateFiles($event)" />
            </v-col>
            <v-col cols="2" class="text-end">
                <v-btn @click="submitUpload" :disabled="files.length <= 0" class="mt-3 ml-3 success">{{
                    "Upload" | t
                }}</v-btn>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-list>
            <v-list-item
                style="border-radius: 10px; margin-bottom: 5px; background-color: #F0F0F0"
                v-for="file in activeProduct.product_files_data"
                :key="file.id"
            >
                <v-list-item-content>
                    <v-list-item-title class="subtitle-1" v-text="file.name" />
                </v-list-item-content>
                <v-list-item-action>
                    <v-row no-gutters>
                        <v-btn @click="downloadFile(file.id)" icon>
                            <v-icon color="blue lighen-1">fal fa-file-download</v-icon>
                        </v-btn>
                        <v-btn
                            @click="removeFile(file.id)"
                            icon
                            v-if="hasPermissionForAction(PermissionsConstants.PRODUCT, PermissionsConstants.UPLOAD)"
                        >
                            <v-icon color="bal-red">fal fa-trash-alt</v-icon>
                        </v-btn>
                    </v-row>
                </v-list-item-action>
            </v-list-item>
            <v-list-item
                v-if="activeProduct && activeProduct.product_files_data && activeProduct.product_files_data.length <= 0"
            >
                <v-list-item-content>
                    <v-list-item-title>{{ "No files found" | t }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import Store from "../../../store";
import settings from "../../../settings";
import { PermissionsConstants } from "@/permissions";

export default {
    name: "file-tab",
    computed: {
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        },
        ...mapState("ProductStore", ["activeProduct", "files"])
    },
    methods: {
        ...mapActions("ProductStore", ["getProductData"]),
        updateFiles(e) {
            Store.commit("ProductStore/setFiles", { value: e });
        },
        submitUpload() {
            Store.dispatch("ProductStore/submitFileUpdate", {
                product: this.activeProduct,
                files: this.files
            });
        },
        removeFile(id) {
            if (confirm("Are you sure?")) {
                Store.dispatch("ProductStore/removeFile", {
                    file_id: id,
                    product_id: this.activeProduct.id
                });
            }
        },
        downloadFile(id) {
            let params = "?act=download_file";
            params += "&file_id=" + id;
            window.location.href = settings.api_url + "/file" + params;
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}
</style>
